<template>
  <div class="pdf-exporter" :class="{'show': show}" :style="{height: selectorHeight + 'px'}" v-scroll="scroll">
    <div class="container">
      <div class="window" :class="{'setting': showSetting, 'doing': pdfStatus == 1, 'success': pdfStatus == 2}">
        <div class="pdf-window">
          <i class="icon-close" @click="closeWindow"></i>
          <div class="window-title">
            {{$t('operation.createPDF')}}
          </div>
          <div class="pdf-name-line">
            <input type="text" class="pdf-name" :class="{'require': nameRequire}" :placeholder="$t('operation.pdfName')" v-model="fileName" v-on:keyup="onChange">
            <span class="pdf-setting" @click="showAdvancedSetting">{{$t('operation.pdfSet')}}<i class="icon-down-arrow"></i></span>
          </div>
          <!-- PDF的配置选项 -->
          <div class="setting-options">
            <div class="options-wrapper">
              <div class="pdf-size">
                <span class="setting-name">{{$t('operation.pdfSize')}}</span>
                <div class="option-items">
                  <span class="item" :class="{'active': pdfOptions.pdfType == 0}" @click="sizeSetting(0)">{{$t('operation.autoAdjustment')}}</span>
                  <span class="item" :class="{'active': pdfOptions.pdfType == 1}" @click="sizeSetting(1)">A3</span>
                  <span class="item" :class="{'active': pdfOptions.pdfType == 2}" @click="sizeSetting(2)">A4</span>
                  <span class="item" :class="{'active': pdfOptions.pdfType == 3}" @click="sizeSetting(3)">A5</span>
                  <span class="item" :class="{'active': pdfOptions.pdfType == 7}" @click="sizeSetting(7)">B5</span>
                </div>
              </div>
              <div class="direction-quality-group">
                <div class="pdf-direction">
                  <span class="setting-name">{{$t('operation.pdfDirection')}}</span>
                  <div class="option-items">
                    <span class="item" :class="{'active': pdfOptions.horizontal == 0}" @click="directionSetting(0)">{{$t('operation.vertical')}}</span>
                    <span class="item" :class="{'active': pdfOptions.horizontal == 1}" @click="directionSetting(1)">{{$t('operation.horizontal')}}</span>
                  </div>
                </div>
                <div class="pdf-quality">
                  <span class="setting-name">{{$t('operation.pdfQuality')}}</span>
                  <div class="option-items">
                    <span class="item mar-right-5" :class="{'active': pdfOptions.qualityType == 1}" @click="qualitySetting(1)">{{$t('operation.standard')}}</span>
                    <span class="item" :class="{'active': pdfOptions.qualityType == 2}" @click="qualitySetting(2)">{{$t('operation.maximum')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 确定和取消 -->
          <div class="button-group">
            <button class="btn-black confirm" @click="confirm">{{$t('operation.confirm')}}</button>
            <button class="btn-grey cancel" @click="closeWindow">{{$t('list.cancel')}}</button>
          </div>
        </div>
        <div class="pdf-process">
          <div class="process-percentage">
            <span class="percentage-value">{{percentage}}</span>
            <span class="percentage-symbol">%</span>
          </div>
          <div class="bar-container">
            <div class="bar-value" :style="{width: percentage + '%'}">
            </div>
          </div>
        </div>
        <div class="pdf-success">
          <div class="pdf-result-icon">
            <i class="icon-select"></i>
          </div>
          <div class="result-text">
            {{$t('operation.pdfCreated')}}
          </div>
          <div class="result-btn">
            <button class="btn-black done" @click="generatePDFSuccess">{{$t('operation.done')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as Config from 'common/script/config'
export default {
  name: 'pdfExporter',
  props: ['show', 'text', 'pdfStatus', 'percentage'],
  created: function () {
    var size = Config.documentSize()
    this.selectorHeight = size.height
  },
  data () {
    return {
      selectorHeight: 0,
      showSetting: false,
      fileName: '',
      pdfOptions: {
        fileName: '',
        pdfType: 0, // 纸张类型， 0:自适应，1:A3, 2:A4, 3:A5, 4:A6, 5:B3, 6:B4, 7:B5, 8:B6
        qualityType: 1, // PDF质量，1:标准，2:最优
        horizontal: 0 // 是否横向, 0:纵向， 1:横向
      },
      nameRequire: false
    }
  },
  watch: {
    fileName: function (newVal, oldVal) {
      this.pdfOptions.fileName = Config.removeEmoji(newVal)
      this.fileName = Config.removeEmoji(newVal)
    }
  },
  methods: {
    scroll: function (event) {
      event = event || window.event
      if (event.preventDefault) {
        // Firefox
        event.preventDefault()
        event.stopPropagation()
      } else {
        // IE
        event.cancelBubble = true
        event.returnValue = false
      }
    },
    onChange: function () {
      this.fileName = this.fileName.substring(0, 20)
    },
    showAdvancedSetting: function () {
      this.showSetting = !this.showSetting
    },
    sizeSetting: function (value) {
      this.pdfOptions.pdfType = value
    },
    directionSetting: function (value) {
      this.pdfOptions.horizontal = value
    },
    qualitySetting: function (value) {
      this.pdfOptions.qualityType = value
    },
    confirm: function () {
      // console.log('pdf generate')
      if (this.pdfOptions.fileName === '') {
        this.nameRequire = true
      } else {
        this.nameRequire = false
        this.$emit('confirmPDFAction', this.pdfOptions)
      }
    },
    generatePDFSuccess: function () {
      this.$router.push('/et/pdf')
    },
    closeWindow: function () {
      this.$emit('closePdfWindow')
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.pdf-exporter
  position absolute
  width 100%
  top 0px
  left 0px
  background-color rgba(0, 0, 0, 0.4)
  z-index 99
  .container
    position relative
    display block
    width 100%
    height 100%
    .window
      position absolute
      width 420px
      height 170px
      top 50%
      left 50%
      margin-left -200px
      margin-top -170px
      padding 0px 23px
      background-color #ffffff
      border-radius 4px
      line-height initial
      box-sizing border-box
      transition height 0.3s ease-in
      &.setting
        height 340px
        .pdf-window
          .setting-options
            height 170px
      &.doing, &.success
        height 170px
      .pdf-window
        position relative
        display block
        width 100%
        height 100%
        .icon-close
          position absolute
          top 13px
          right 13px
          font-size 12px
          cursor pointer
        .window-title
          padding 13px 0px
          font-size 16px
          line-height 16px
          text-align center
        .pdf-name-line
          display flex
          width 100%
          height 31px
          padding 0px 3px
          flex-direction row
          justify-content space-between
          line-height 31px
          font-size 12px
          box-sizing border-box
          .pdf-name
            width 280px
            padding 8px 8px
            text-align center
            font-size 12px
            color #000000
            background-color #f5f5f5
            border-radius 4px
            box-sizing border-box
            outline none
            &::-webkit-input-placeholder
              color #999
            &::-ms-input-placeholder
              color #999
            &::-ms-clear
              display none
            &.require
              border 1px solid #e36868
          .pdf-setting
            line-height 34px
            cursor pointer
            .icon-down-arrow
              margin-left 4px
        .setting-options
          margin-top 20px
          width 100%
          height 0px
          overflow hidden
          transition height 0.3s ease-in
          .options-wrapper
            width 100%
            height 100%
            margin 1px 0px
            padding 20px 0px
            border-top 1px solid #cacaca
            border-bottom 1px solid #cacaca
            box-sizing border-box
            text-align left
            .setting-name
              display block
              height 16px
              line-height 16px
              font-size 12px
              font-weight bold
              padding 2px 0px
            .option-items
              display flex
              width 100%
              padding 2px 0px
              flex-direction row
              justify-content space-between
              .mar-right-5
                margin-right 5.3px
              .item
                min-width 70px
                padding-left 3px
                padding-right 3px
                height 30px
                line-height 30px
                text-align center
                font-size 12px
                border 1px solid #cacaca
                border-radius 4px
                box-sizing border-box
                color #000000
                background-color #ffffff
                cursor pointer
                &.active
                  color #ffffff
                  background-color #3d3d3d
                  border none
            .pdf-size
              width 100%
            .direction-quality-group
              display flex
              width 100%
              margin-top 14px
              flex-direction row
              justify-content space-between
              .pdf-direction
                width 39%
              /*.pdf-quality*/
              /*  width 42.5%*/
        .button-group
          width 100%
          height 30px
          line-height 30px
          margin-top 30px
          text-align center
          font-size 12px
          .confirm, .cancel
            min-width 80px
            padding-left 7px
            padding-right 7px
            height 30px
            line-height 30px
            margin 0 4px
      .pdf-process
        display none
        .process-percentage
          width 100%
          margin-top 48px
          text-align center
          color #000000
          .percentage-value
            font-size 30px
          .percentage-symbol
            font-size 12px
        .process-text
          width 100%
          padding 10px 0px
          text-align center
          font-size 14px
        .bar-container
          position relative
          width 300px
          height 2px
          margin 36px auto
          border-radius 1px
          background-color #f5f5f5
          .bar-value
            height 2px
            border-radius 1px
            background-color #3d3d3d
            transition width 0.2s
      .pdf-success
        display none
        .pdf-result-icon
          padding-top 40px
          width 100%
          text-align center
          font-size 36px
          color #3d3d3d
        .result-text
          width 100%
          text-align center
          font-size 12px
          line-height 16px
          color #000000
        .result-btn
          width 100%
          height 30px
          line-height 30px
          padding-top 25px
          text-align center
          .done
            width 80px
            height 30px
            line-height 30px
      &.doing
        .pdf-window
          display none
        .pdf-process
          display block
        .pdf-success
          display none
      &.success
        .pdf-window
          display none
        .pdf-process
          display none
        .pdf-success
          display block
</style>



// WEBPACK FOOTER //
// src/components/Et/PdfExporter.vue